import React from 'react';
import styled from 'styled-components';
import {NAVIGATED_TO_SEARCHGALLERY} from '../../actions/actionTypes';
import Link from "../InternalLink";

const LinkedPatternKeywords = ({tags}) => {

    const StyledThing = styled.div`
      
    `;

    const buildLinkedTags = () => {
        const getAction = search => ({type: NAVIGATED_TO_SEARCHGALLERY, meta: {query: {q: search}}});
        const keywords = tags.split( "," );
        const searchItems = keywords.map( keyword => keyword.trim() );
        return searchItems.map( (search, index, items) => {
            if(items.length === index + 1){
                return [<Link key={index} to={getAction(search)}>{search}</Link>]
            }
            return [<Link key={index} to={getAction(search)}>{search}</Link>, ',  ']
        });

    };

    return (
        <StyledThing>
            {buildLinkedTags()}
        </StyledThing>
    );
};

export default LinkedPatternKeywords;



// WEBPACK FOOTER //
// ./src/components/pattern/LinkedPatternKeywords.js